import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "a-noPostsFeedback m-container__row -justifyCenter",
  style: {"padding-top":"10rem"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "a-title -enormous -center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "a-text -center" }, "Brak postów do wyświetlenia", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: `${_ctx.basePath}/wp-content/uploads/2022/06/baner-1024x126-1.png`,
        alt: "",
        class: "o-home__bannerImage a-image"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _hoisted_4
  ]))
}